import { Component, OnInit, inject } from "@angular/core";
import { BalanceService } from "../../services/balance.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { Auth } from "aws-amplify";

@Component({
  selector: "app-balance",
  templateUrl: "./balance.component.html",
  styleUrls: [],
})
export class BalancesComponent implements OnInit {
  private balanceSvc = inject(BalanceService);
  public router = inject(Router);
  authService = inject(AuthService);

  balance: number | null = null;
  currency: string = "EUR";
  private subscription: Subscription = new Subscription();

  async ngOnInit() {
    // Suscribirse ANTES de los awaits para capturar inmediatamente el valor cacheado
    // si existe (visita posterior), o mostrar el skeleton si es la primera vez (null).
    this.subscription = this.balanceSvc.balance$.subscribe(balance => {
      this.balance = balance;
    });

    try {
      await this.authService.refresh();
      await Auth.currentAuthenticatedUser();
      // Refrescar desde el backend en background. Si ya había caché, el valor
      // actual se muestra mientras llega la respuesta actualizada.
      this.balanceSvc.calculateBalance();
    } catch (error) {
      this.authService.logout();
    }
  }

  get isLoading(): boolean {
    return this.balance === null;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
